import request from '../request'

// 查询月报参数配置
export function fetchProgressReportConfig(params) {
    return request({
        url: '/finance-service/progress-report/config',
        method: 'get',
        params
    })
}

// 保存月报参数配置（单行更新）
export function saveProgressReportConfig(data) {
    return request({
        url: '/finance-service/progress-report/config/save',
        method: 'post',
        data
    })
}

// 确认月报（写入经管对接人与确认日期）
export function confirmProgressReport(data) {
    return request({
        url: '/finance-service/progress-report/confirm',
        method: 'post',
        data
    })
}

// 查询月报详情（含明细）
export function fetchProgressReportDetail(params) {
    return request({
        url: '/finance-service/progress-report/detail',
        method: 'get',
        params
    })
}

// 生成期初数据（默认当前月，可指定年月）
export function generateInitialData(data) {
    return request({
        url: '/finance-service/progress-report/generate/initial',
        method: 'post',
        data
    })
}

// 生成月度数据（默认当前月，可指定年月；sendTodo=false 时不发确认待办，便于测试）
export function generateMonthlyData(data) {
    return request({
        url: '/finance-service/progress-report/generate/monthly',
        method: 'post',
        data
    })
}

// 分页查询月报列表
export function fetchProgressReportList(params) {
    return request({
        url: '/finance-service/progress-report/list',
        method: 'get',
        params
    })
}

/**
 * 生成月度数据
 * @param {Object} params
 * @param {number} [params.year] 年份
 * @param {number} [params.month] 月份
 * @param {boolean} [params.sendTodo=true] 是否发送待办，测试传false
 */
export function generateMonthlyReport(params) {
    return request({
        url: `/finance-service/progress-report/generate/monthly`,
        method: 'post',
        params, // year、month、sendTodo 都是query参数，放在params
    })
}